import React from 'react'
import { ArrowLongRightIcon } from '@heroicons/react/24/solid'
import RadiusSelect from './RadiusSelect'
import DateTimeControl from './DateTimeControl'

function RouteSection({
	pickup,
	dropOff,
	originRadius,
	destinationRadius,
	updatedPickupTime,
	updatedDeliveryTime,
	onOriginRadiusChange,
	onDestinationRadiusChange,
	onUpdatePickupTime,
	onUpdateDeliveryTime,
	formatCity,
	formatTime,
	disabled = false,
	isDarkMode = false,
}) {
	return (
		<div className="grid grid-cols-1 lg:grid-cols-[1fr,auto,1fr] gap-4 mb-6">
			<div className="py-2 px-2">
				<div className="flex items-start gap-3 mb-2">
					<div
						className={`text-sm font-medium tracking-wide ${
							isDarkMode ? 'text-white' : 'text-gray-900'
						}`}
					>
						{formatCity(pickup)}
					</div>
					<span
						className={`text-sm ${
							isDarkMode ? 'text-gray-400' : 'text-gray-500'
						}`}
					>
						|
					</span>
					<RadiusSelect
						value={originRadius}
						onChange={onOriginRadiusChange}
						disabled={disabled}
						isDarkMode={isDarkMode}
					/>
				</div>

				<DateTimeControl
					time={updatedPickupTime}
					timezone={pickup?.timezone}
					onDecrease={() => onUpdatePickupTime(-1)}
					onIncrease={() => onUpdatePickupTime(1)}
					disabled={disabled}
					isDarkMode={isDarkMode}
					formatTime={formatTime}
				/>
			</div>

			<div className="flex items-center justify-center px-2">
				<ArrowLongRightIcon
					className={`w-6 h-6 flex-shrink-0 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-600'
					}`}
				/>
			</div>

			<div className="py-2 px-2 ml-4">
				<div className="flex items-start gap-3 mb-2">
					<div
						className={`text-sm font-medium tracking-wide ${
							isDarkMode ? 'text-white' : 'text-gray-900'
						}`}
					>
						{formatCity(dropOff)}
					</div>
					<span
						className={`text-sm ${
							isDarkMode ? 'text-gray-400' : 'text-gray-500'
						}`}
					>
						|
					</span>
					<RadiusSelect
						value={destinationRadius}
						onChange={onDestinationRadiusChange}
						disabled={disabled}
						isDarkMode={isDarkMode}
					/>
				</div>

				<DateTimeControl
					time={updatedDeliveryTime}
					timezone={dropOff?.timezone}
					onDecrease={() => onUpdateDeliveryTime(-1)}
					onIncrease={() => onUpdateDeliveryTime(1)}
					disabled={disabled}
					isDarkMode={isDarkMode}
					formatTime={formatTime}
				/>
			</div>
		</div>
	)
}

export default RouteSection
